var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37781 34.0013L4.57031 2.5H35.4303L32.6191 33.9963L19.9816 37.5L7.37781 34.0013Z",
    fill: "#1572B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 34.8244L30.2125 31.9931L32.615 5.07812H20V34.8244Z",
    fill: "#33A9DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.488H25.1125L25.465 12.5317H20V8.66797H20.0137H29.6875L29.595 9.70422L28.6462 20.3517H20V16.488Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0245 26.5239L20.007 26.5289L15.7045 25.3664L15.4295 22.2852H13.3383H11.5508L12.092 28.3514L20.0058 30.5489L20.0245 30.5439V26.5239Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7855 20.1875L24.3205 25.3613L20.0117 26.5238V30.5438L27.9317 28.3488L27.9905 27.6963L28.6617 20.1875H24.7855Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0147 8.66797V11.068V12.5217V12.5317H10.6947H10.6822L10.6047 11.663L10.4284 9.70422L10.3359 8.66797H20.0147Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.4883V18.8883V20.342V20.352H15.7638H15.7512L15.6737 19.4833L15.4988 17.5245L15.4062 16.4883H20Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.07dd156e07c5d624ed24d37302edc517.svg";
export { ForwardRef as ReactComponent };